import { render, staticRenderFns } from "./yhList.vue?vue&type=template&id=6500b1fc&"
import script from "./yhList.vue?vue&type=script&lang=js&"
export * from "./yhList.vue?vue&type=script&lang=js&"
import style0 from "./yhList.vue?vue&type=style&index=0&id=6500b1fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports